"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_popper_1 = require("react-popper");

var styles_1 = require("../../styles");

function PopperContent(props) {
  var show = props.show,
      offset = props.offset,
      children = props.children,
      rest = __rest(props, ["show", "offset", "children"]);

  var _a = styles_1.useStyles(exports.createStyles, props),
      classes = _a.classes,
      css = _a.css;

  return react_1.default.createElement(react_popper_1.Popper, __assign({}, rest), function (popperProps) {
    return react_1.default.createElement("div", {
      ref: popperProps.ref,
      style: popperProps.style,
      className: css(classes.content, show ? classes.visible : classes.hidden),
      "data-visible": show
    }, children);
  });
}

exports.PopperContent = PopperContent;
PopperContent.defaultProps = {
  show: false,
  offset: 0.25
};

exports.createStyles = function (theme, _a) {
  var offset = _a.offset;
  return {
    content: {
      transition: 'opacity .2s',
      zIndex: theme.zIndex.popper,
      padding: offset + "rem"
    },
    visible: {
      visibility: 'visible',
      opacity: 1
    },
    hidden: {
      visibility: 'hidden',
      opacity: 0
    }
  };
};